import { Compass } from "lucide-react";

export function NoMatch({ onChange, onWholeWorld, dark }) {
  return (
    <div className="ww-nomatch" data-testid="viewer-no-match" style={dark ? { color: "var(--ww-white-warm)" } : undefined}>
      <Compass size={54} strokeWidth={1.4} className="ww-nomatch-art" />
      <h2 className="ww-display" style={dark ? { color: "var(--ww-white-warm)" } : undefined}>
        We haven't found that world yet.
      </h2>
      <p style={dark ? { color: "rgba(251,246,238,0.75)" } : undefined}>
        There aren't any shared photographs matching this journey just yet.
      </p>
      <div className="ww-nomatch-actions">
        <button className="ww-btn ww-btn-outline" data-testid="no-match-change" onClick={onChange}>
          Change where &amp; when
        </button>
        <button className="ww-btn ww-btn-primary" data-testid="no-match-whole-world" onClick={onWholeWorld}>
          Show Me The World
        </button>
      </div>
    </div>
  );
}
